<template>
  <div class="main common-table-cnt search">
    <el-form :inline="true" :model="formInline" class=" demo-form-inline" style="overflow: auto;">
      <el-form-item :label="$t('mechanism')">
        <el-select
          ref="paramOuSelect"
          v-model="formInline.ouName"
          style="width:auto"
          :placeholder="$t('peaseSelect')"
          @change="changeParamOu"
          clearable
          @visible-change="visibleChange"
        >
          <el-option :value="formInline.ouName" style="height:auto;padding:0px">
            <el-tree
              ref="paramOuTree"
              node-key="id"
              default-expand-all
              highlight-current
              :expand-on-click-node="false"
              :data="ouList"
              :props="defaultProps"
              @node-click="selectParamOu"
            >
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('userNameH')" v-if="!userId">
        <el-input v-model="formInline.userName" clearable :placeholder="$t('userNameH')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('appName')">
        <el-input v-model="formInline.appName" clearable :placeholder="$t('appName')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('serialNumberP')">
        <el-input v-model="formInline.helmetId" clearable :placeholder="$t('serialNumberP')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('Recordtime')" class="datetime">
        <el-date-picker
          v-model="formInline.searchTimeB"
          :placeholder="$t('startDate')"
          type="date"
          value-format="yyyy-MM-dd"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('TO')" class="datetime">
        <el-date-picker
          v-model="formInline.searchTimeE"
          :placeholder="$t('endDate')"
          type="date"
          value-format="yyyy-MM-dd"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{ $t('query') }}</el-button>
        <el-button
          type="primary"
          class="serachBtn letter_delet"
          v-has="isDefaultTheme ? 'sys:new:setting:log:data:delete' : 'log:data:delete'"
          @click="handleDelet"
          v-preventReClick="1000"
          >{{ $t('batchDelete') }}</el-button
        >
        <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="total-flow">
      <span
        >{{ $t('totalFlow') }}：<i class="log-num">{{ statisData.sum_of_volume }}</i></span
      >
      <span
        >{{ $t('averageflow') }}：<i class="log-num">{{ statisData.avg_of_volume }}</i></span
      >
    </div>
    <Table
      v-loading="loading"
      :data="tableData"
      :columns="columns"
      :operation="dateOperation"
      :tableHeight="600"
      :type="type"
      ref="tanleAssembly"
      @getList="getList"
      @operate="operationEvent"
      :currentPage="currentPage"
      :pageSize="pageSize"
      :operationWidth="100"
      @sortChange="handleSort"
    ></Table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalData"
    >
    </el-pagination>
  </div>
</template>

<script>
import Table from '@/components/NewTable'
import { getMobileDatas, deleteMobileDataLog, mobileDatasAppNames, mobileDatasStatistics } from '@/api/log'
import { mapState } from 'vuex'
import { getOus } from '@/api/UserList'
import { getExportMobileDatas } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
export default {
  name: 'MobileData',
  props: {
    // 实时监控》历史记录》组件弹窗传用户名
    userId: {
      type: String,
    },
  },
  data() {
    return {
      ouList: [],
      // 查询表单字段
      formInline: {
        ouName: '',
        ouId: '',
        helmetId: '',
        userName: '',
        appName: '',
        searchTimeB: beforeWeekDate(),
        searchTimeE: nowDate(),
      },
      currentPage: 1,
      pageSize: 10,
      // 请求数据的总条数
      totalData: 0,
      // 表头数组
      columns: [],
      // 操作栏数组
      dateOperation: [],
      // table数据
      tableData: [],
      // 数据流量appNameList
      appNames: [],
      // 流量数据
      statisData: {},
      // 用于批量删除 公共组件类型判断
      type: 'mobileData',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  computed: {
    ...mapState(['isDefaultTheme']),
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if(this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.searchTimeB,
        logDateEnd: this.formInline.searchTimeE,
        appName: this.formInline.appName,
        userName: this.formInline.userName,
        userId: this.userId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getExportMobileDatas(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('DataFlowrecord') + '.xls')
      })
    },
     // 排序
     handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc =  data.order=== "descending" ? 0 : 1
      this.getList()
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 批量删除
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this.delectMobileLog(row)
      }
    },
    // 删除记录
    delectMobileLog(row) {
      this.$confirm(this.$t('deleteTip'), '提示', {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = {
          userId: row.value.userId,
          sid: row.value.sid,
          logTimestamp: row.value.logTimestamp,
        }
        deleteMobileDataLog(params).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      // 清空批量选择的数据
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this.basicConfig()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.searchTimeB, this.formInline.searchTimeE)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.basicConfig()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this.basicConfig()
      }
    },
    basicConfig() {
      this.loading = true
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.searchTimeB,
        logDateEnd: this.formInline.searchTimeE,
        appName: this.formInline.appName,
        userName: this.formInline.userName,
        userId: this.userId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      // param.userName = this.userName === undefined ? this.formInline.userName : this.userName
      // 请求table 数据
      getMobileDatas(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
      // 请求 总/平均流量
      mobileDatasStatistics(param).then(res => {
        if (res.state === 0) {
          this.statisData = res.value
        }
      })
      // 表头设置
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
          sort: 'userName',
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
          sort: 'helmetId',
        },
        {
          attrName: 'volume',
          label: this.$t('flow') + '(KB)',
          sort: 'volume',
        },
        {
          attrName: 'appName',
          label: this.$t('appName'),
          sort: 'appName',
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('Recordtime'),
          align: 'center',
          width: '180',
          sort: 'logTimestamp',
        },
        {
          attrName: 'uploadTimestamp',
          label: this.$t('uploadTimestamp'),
          align: 'center',
          width: '180',
          sort: 'uploadTimestamp',
        },
      ]
      // 操作栏
      this.dateOperation = [
        {
          operateName: '',
          icon: this.isDefaultTheme ? require('@/icon/ic_delete.png') : require('@/icon/new-common/icon_delete.png'),
          type: 'delect',
          IsHad: '',
        },
      ]
    },
    // 查询获取数据流量appNameList
    getAppNames() {
      mobileDatasAppNames().then(res => {
        if (res.state === 0) {
          this.appNames = []
          for (let i = 0; i < res.value.length; i++) {
            this.appNames.push({ value: res.value[i], label: res.value[i] })
          }
        }
      })
    },
  },
  created() {
    this.basicConfig()
    // this.getAppNames()
    this.getOusTree()
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.total-flow {
  margin-bottom: 0px;
  line-height: 36px;
  background: #f0f9ff;
  border: 1px solid var(--border-grey);
  border-bottom: none;

  span {
    margin-left: 10px;
    font-weight: 600;

    &:first-child {
      margin-left: 20px;
    }
  }
}

.letter_delet {
  margin-left: 10px;
}
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
>>> .el-tree
  height 100%
  background: var(--new-tree-bg)
  color: var(--new-el-select-dropdown-item)
>>>.el-tree-node
  height: 100%
>>>.el-tree-node__content:hover .editBtn
    display inline-block
>>>.el-input__prefix, >>>.el-input__suffix
  color #fff
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.el-select-dropdown
  .el-select-dropdown__list
    .el-select-dropdown__item.hover
      background-color var(--new-tree-bg)
// 深色
.theme-dark {
  .total-flow {
    background: #072368;
    border: 1px solid #0057A8;
  }
}

.common-blue-contain {
  .el-pagination {
    margin-top: 18px;
  }
}
.bg-contain .common-table-cnt:has(.total-flow) /deep/ .el-table {
  height: 560px !important;
}
>>>.el-popper
 min-width 100%!important
</style>
